export const CREATE_GRAY_JOB_RECEIVE_RETURN = 'CREATE_GRAY_JOB_RECEIVE_RETURN';
export const GET_GRAY_JOB_RECEIVE_RETURNS = 'GET_GRAY_JOB_RECEIVE_RETURNS';
export const GRAY_JOB_RECEIVE_RETURN_REQUEST = 'GRAY_JOB_RECEIVE_RETURN_REQUEST';
export const UPDATE_GRAY_JOB_RECEIVE_RETURN = 'UPDATE_GRAY_JOB_RECEIVE_RETURN';
export const DELETE_GRAY_JOB_RECEIVE_RETURN = 'DELETE_GRAY_JOB_RECEIVE_RETURN';
export const GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE = 'GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE';